import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = ["fill", "stroke"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8 8.81496V4.40234",
  stroke: "white",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = ["stroke"]
const _hoisted_5 = ["stroke"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.99793 11.4841C7.87617 11.4841 7.77734 11.3854 7.77734 11.2636C7.77734 11.1417 7.87617 11.043 7.99793 11.043",
  stroke: "white"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8 11.4841C8.12185 11.4841 8.22059 11.3854 8.22059 11.2636C8.22059 11.1417 8.12185 11.043 8 11.043",
  stroke: "white"
}, null, -1)

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'warningIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#F7553C",
  },
  size: {
    type: Number as PropType<number>,
    default: 16,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: __props.size,
    height: __props.size,
    viewBox: `0 0 ${__props.size} ${__props.size}`,
    fill: "none"
  }, [
    _createElementVNode("path", {
      d: "M15.0591 7.80803C15.0642 9.69309 14.326 11.5041 13.0046 12.8485C11.6832 14.1928 9.88511 14.9621 8.00023 14.9895C7.07985 15.0034 6.1658 14.8345 5.31118 14.4924C4.45656 14.1503 3.67837 13.642 3.02173 12.9968C2.36509 12.3516 1.84308 11.5826 1.48598 10.7341C1.12887 9.88562 0.943779 8.97477 0.941432 8.05421C0.93635 6.16911 1.67453 4.35796 2.99589 3.01347C4.31726 1.66897 6.11534 0.8995 8.00023 0.871873C8.9207 0.858091 9.83482 1.02719 10.6894 1.36935C11.544 1.71152 12.3222 2.21996 12.9788 2.86517C13.6355 3.51039 14.1575 4.27955 14.5146 5.12803C14.8716 5.97653 15.0568 6.88747 15.0591 7.80803Z",
      fill: __props.color,
      stroke: __props.color,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, _hoisted_2),
    _hoisted_3,
    _createElementVNode("path", {
      d: "M7.99962 11.0391H7.99609",
      stroke: __props.color,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, _hoisted_4),
    _createElementVNode("path", {
      d: "M8.00088 11.0391H8",
      stroke: __props.color,
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 8, _hoisted_5),
    _hoisted_6,
    _hoisted_7
  ], 8, _hoisted_1))
}
}

})